function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 4,
  height: 4,
  rx: 1
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 10,
  width: 4,
  height: 4,
  rx: 1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 4,
  width: 4,
  height: 4,
  rx: 1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 10,
  width: 4,
  height: 4,
  rx: 1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 4,
  width: 4,
  height: 4,
  rx: 1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 10,
  width: 4,
  height: 4,
  rx: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 16,
  width: 4,
  height: 4,
  rx: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 16,
  width: 4,
  height: 4,
  rx: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 4,
  height: 4,
  rx: 1
});

var SvgIcModeBrowse24 = function SvgIcModeBrowse24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjUgKDY3NDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pYy1tb2RlLWJyb3dzZS0yNDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvMjQvTW9kZS1Ccm93c2UiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgeD0iNCIgeT0iNCIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03IiB4PSI0IiB5PSIxMCIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03IiB4PSIxMCIgeT0iNCIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03IiB4PSIxMCIgeT0iMTAiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgeD0iMTYiIHk9IjQiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgeD0iMTYiIHk9IjEwIiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTciIHg9IjQiIHk9IjE2IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTciIHg9IjEwIiB5PSIxNiIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03IiB4PSIxNiIgeT0iMTYiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgIcModeBrowse24 as ReactComponent };